<template>
  <div>
    <div class="progressOut" v-for="item in pieList" :key="item.type">
      <div class="progressbox">
        <div class="progress_label">
          <span class="">{{ item.type }}</span>
        </div>
        <label class="progress_bar">
          <label class="des_info">License占比</label>
          <label class="des_time pull_right">{{getRound(item.percentage)}}%</label>
          <Tooltip :title="getRound(item.percentage)+'%'" overlayClassName="health_perfect_tooltip">
            <Progress :percent="getRound(item.percentage)" :showInfo="false" strokeColor="#0091FF" />
          </Tooltip>
        </label>
      </div>
      <p>
        <span>{{ item.total }}</span>
        <span>License总数</span>
      </p>
      <p v-show="item.active>=0">
        <span>{{ item.active }}</span>
        <span>已激活</span>
      </p>
      <p v-show="item.unActive>=0">
        <span>{{ item.unActive }}</span>
        <span>未激活</span>
      </p>
      <p v-show="item.formal>=0">
        <span>{{ item.formal }}</span>
        <span>正式</span>
      </p>
      <p v-show="item.poc>=0">
        <span>{{ item.poc }}</span>
        <span>POC</span>
      </p>
      <p v-show="item.trial>=0">
        <span>{{ item.trial }}</span>
        <span>试用</span>
      </p>
      <p v-show="item.subs>=0">
        <span>{{item.subs}}</span>
        <span>订阅式</span>
      </p>
      <p v-show="item.unSubs>=0">
        <span>{{item.unSubs}}</span>
        <span>买断式</span>
      </p>
      <p v-show="item.expired>=0">
        <span>{{item.expired}}</span>
        <span>已过期</span>
      </p>
      <p v-show="item.unExpired>=0">
        <span>{{item.unExpired}}</span>
        <span>时间充足</span>
      </p>
      <p v-show="item.toExpire>=0">
        <span>{{item.toExpire}}</span>
        <span>即将过期</span>
      </p>
      <p v-show="item.delivery>=0">
        <span>{{item.delivery}}</span>
        <span>交付</span>
      </p>
      <p v-show="item.service>=0">
        <span>{{item.service}}</span>
        <span>服务</span>
      </p>
      <p v-show="item.envTest>=0">
        <span>{{item.envTest}}</span>
        <span>测试</span>
      </p>
      <p v-show="item.envProduction>=0">
        <span>{{item.envProduction}}</span>
        <span>生产</span>
      </p>
      <p v-show="item.envPoc>=0">
        <span>{{item.envPoc}}</span>
        <span>POC</span>
      </p>
      <p v-show="item.envFormal>=0">
        <span>{{item.envFormal}}</span>
        <span>正式</span>
      </p>
      <p v-show="item.envRenewal>=0">
        <span>{{item.envRenewal}}</span>
        <span>续约</span>
      </p>
    </div>
  </div>
</template>

<script>
import { Tooltip, Progress, Icon } from 'ant-design-vue'
import round from 'lodash/round'
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('statis')
export default {
  name: 'Statistics',
  props: {
    pieList: Array
  },
  data() {
    return {
    }
  },

  created() {
    
  },
  computed: {
    ...mapState(['licenses']),

  },
  methods:{
    getRound(text){
      return round(text)
    }
  },
  components: {
    Tooltip,
    Progress,
    Icon,
  },
}
</script>
